export default __webpack_public_path__ + "static/media/registrationComplete.7b65f217.png";